import styled from "styled-components";
import { LabelMedium } from "./OnboardingTypography";
import { THEME } from "./OnboardingLayoutComponents";

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${THEME.spacing.sm};
  width: 200px;
`;

const StyledSelect = styled.select`
  padding: ${THEME.spacing.sm} ${THEME.spacing.xxxl} ${THEME.spacing.sm} ${THEME.spacing.sm};
  border: 1px solid ${THEME.colors.border};
  border-radius: ${THEME.borderRadius.sm};
  background-color: ${THEME.colors.white};
  color: ${THEME.colors.text};
  font-size: 16px;
  cursor: pointer;
  transition: ${THEME.transitions.fast};

  &&:focus {
    outline: none;
    border-color: ${THEME.colors.primary};
  }
`;

const StyledOption = styled.option`
  padding: ${THEME.spacing.sm};
  color: ${THEME.colors.text};
`;

const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OnboardingDropdown = ({ label, items, onChange, defaultValue, value, required = false }) => {
  return (
    <DropdownWrapper>
      <LabelMedium>
        {label}
        {required && <span style={{ color: THEME.colors.error || "#d32f2f" }}> *</span>}
      </LabelMedium>
      <DropdownContainer>
        <StyledSelect
          onChange={onChange}
          value={value !== undefined ? value : defaultValue}
          required={required}
          aria-required={required}
        >
          {items.map((item, index) => (
            <StyledOption key={index} value={item.value}>
              {item.label}
            </StyledOption>
          ))}
        </StyledSelect>
      </DropdownContainer>
    </DropdownWrapper>
  );
};

export default OnboardingDropdown;
